export default __webpack_public_path__ + "static/media/2203.15586687.png";